<template>
	<a-modal
		class="g-header-info-card-v2-edit-modal"
		:visible="visible"
		title="头部模块编辑"
		width="706px"
		:centered="true"
		:mask-closable="false"
		:destroy-on-close="true"
		@cancel="onCancel"
	>
		<div class="g-header-info-card-v2-edit" @click="clearSelection">
			<div class="g-header-info-card-v2-edit__stage" @click.stop>
				<button
					v-if="form.items.length > 1"
					type="button"
					class="g-header-info-card-v2-edit__nav g-header-info-card-v2-edit__nav--prev"
					@click="goPrev"
				>
					<i class="mbm-iconfont mbm-youjiantou g-header-info-card-v2-edit__nav-icon--prev"></i>
				</button>

				<div
					class="g-header-info-card-v2-edit__preview"
					:style="previewWrapStyle"
				>
					<img
						v-if="selectedSlide && getImageUrl(selectedSlide)"
						:src="getImageUrl(selectedSlide)"
						class="g-header-info-card-v2-edit__preview-bg"
						alt=""
					/>
					<div v-else class="g-header-info-card-v2-edit__preview-empty">
						<i class="mbm-iconfont mbm-tupian"></i>
					</div>
					<div
						v-if="selectedSlide"
						class="g-header-info-card-v2-edit__text"
					>
						<input
							v-model="selectedSlide.title"
							type="text"
							class="g-header-info-card-v2-edit__title-input"
							:style="{ color: form.titleColor }"
							maxlength="40"
							placeholder="输入主标题"
						/>
						<input
							v-model="selectedSlide.subtitle"
							type="text"
							class="g-header-info-card-v2-edit__subtitle-input"
							:style="{ color: form.subtitleColor }"
							maxlength="60"
							placeholder="输入副标题"
						/>
					</div>
					<div
						v-if="form.items.length > 1"
						class="g-header-info-card-v2-edit__dots-preview"
					>
						<span
							v-for="(slide, index) in form.items"
							:key="`preview-dot-${slide.id}`"
							class="g-header-info-card-v2-edit__dot-preview"
							:style="getDotPreviewStyle(index)"
						></span>
					</div>
					<div
						class="g-header-info-card-v2-edit__edge"
						:style="{ background: form.edgeColor }"
					></div>
				</div>

				<button
					v-if="form.items.length > 1"
					type="button"
					class="g-header-info-card-v2-edit__nav g-header-info-card-v2-edit__nav--next"
					@click="goNext"
				>
					<i class="mbm-iconfont mbm-youjiantou"></i>
				</button>
			</div>

			<div
				class="g-header-info-card-v2-edit__thumb-row"
				@click.stop
			>
				<EditListSortGroup
					ref="editGrid"
					class="g-header-info-card-v2-edit__thumbs"
					@dragover="onSortDragOver"
				>
					<div
						v-for="(slide, index) in form.items"
						:key="slide.id"
						:data-sort-id="slide.id"
						class="g-header-info-card-v2-edit__thumb-wrap"
						:class="[
							{ 'is-active': selectedIndex === index },
							getEditListSortItemClass(dragId, slide.id, dragOverId),
						]"
					>
						<div
							class="g-header-info-card-v2-edit__thumb"
							:class="{ 'is-selected': selectedIndex === index }"
							draggable="true"
							@dragstart="onDragStart(slide.id, $event)"
							@dragend="onDragEnd"
							@click="selectSlide(index)"
						>
							<UploadProgressPanel
								v-if="isUploading && selectedIndex === index"
								:tasks="uploadTasks"
								variant="item"
								hide-filename
							/>
							<template v-else>
								<img v-if="getImageUrl(slide)" :src="getImageUrl(slide)" alt="" draggable="false" />
								<i v-else class="mbm-iconfont mbm-tupian"></i>
								<button
									type="button"
									class="g-header-info-card-v2-edit__thumb-delete"
									@click.stop="deleteSlide(index)"
								>×</button>
							</template>
						</div>

						<div
							v-if="selectedIndex === index"
							class="g-header-info-card-v2-edit__panel g-header-info-card-v2-edit__panel--arrow g-header-info-card-v2-edit__panel--float"
							@click.stop
						>
							<div class="g-header-info-card-v2-edit__link-row">
								<i class="mbm-iconfont mbm-lianjie"></i>
								<span :class="{ 'is-empty': !jumpLinkLabel }">{{ jumpLinkLabel || '未设置链接' }}</span>
							</div>
							<div class="g-header-info-card-v2-edit__toolbar">
								<button type="button" class="g-header-info-card-v2-edit__action" @click="triggerImageSelect">换图</button>
								<button type="button" class="g-header-info-card-v2-edit__action" @click="jumpLinkVisible = true">换链接</button>
								<span class="g-header-info-card-v2-edit__action-wrap">
									<button
										type="button"
										class="g-header-info-card-v2-edit__action"
										:class="{ 'is-active': activePanel === 'autoplay' || form.autoplay }"
										@click="togglePanel('autoplay')"
									>自动切换</button>
									<div v-if="activePanel === 'autoplay'" class="g-header-info-card-v2-edit__sub-panel">
										<span class="g-header-info-card-v2-edit__sub-label">切换 (秒)</span>
										<a-input-number
											v-model:value="autoplayIntervalDraft"
											:min="1"
											:max="60"
											:precision="0"
											class="g-header-info-card-v2-edit__sub-input"
										/>
										<button type="button" class="g-header-info-card-v2-edit__sub-confirm" @click="applyAutoplayInterval">确定</button>
									</div>
								</span>
								<span class="g-header-info-card-v2-edit__action-wrap">
									<button
										type="button"
										class="g-header-info-card-v2-edit__action"
										:class="{ 'is-active': activePanel === 'height' }"
										@click="togglePanel('height')"
									>高度</button>
									<div v-if="activePanel === 'height'" class="g-header-info-card-v2-edit__sub-panel">
										<span class="g-header-info-card-v2-edit__sub-label">高度 (px)</span>
										<a-input-number
											v-model:value="heightDraft"
											:min="80"
											:max="800"
											:precision="0"
											class="g-header-info-card-v2-edit__sub-input"
										/>
										<button type="button" class="g-header-info-card-v2-edit__sub-confirm" @click="applyHeight">确定</button>
									</div>
								</span>
								<button
									type="button"
									class="g-header-info-card-v2-edit__action g-header-info-card-v2-edit__action--danger-text"
									:disabled="form.items.length <= 1"
									@click="deleteSlide(index)"
								>删除</button>
								<div class="g-header-info-card-v2-edit__colors">
									<ColorPicker
										v-model="form.edgeColor"
										title="底部装饰色"
										@change="onEdgeColorInput"
									/>
									<ColorPicker
										v-model="form.titleColor"
										title="主标题颜色"
										@change="onTitleColorInput"
									/>
									<ColorPicker
										v-model="form.subtitleColor"
										title="副标题颜色"
										@change="onSubtitleColorInput"
									/>
									<ColorPicker
										v-model="form.dotActiveColor"
										title="选中指示点颜色"
										@change="onDotActiveColorInput"
									/>
									<ColorPicker
										v-model="form.dotColor"
										title="指示点颜色"
										@change="onDotColorInput"
									/>
								</div>
							</div>
						</div>
					</div>

					<div
						v-if="form.items.length < maxSlides"
						class="g-header-info-card-v2-edit__thumb g-header-info-card-v2-edit__thumb--add"
						@click="addSlide"
					>
						<span>+</span>
					</div>
				</EditListSortGroup>
				<p class="g-header-info-card-v2-edit__sort-tip">拖动排序</p>
			</div>
		</div>

		<template #footer>
			<button type="button" class="g-header-info-card-v2-edit__footer-btn" @click="onCancel">取消</button>
			<button type="button" class="g-header-info-card-v2-edit__footer-btn is-confirm" :disabled="isUploading" @click="onConfirm">确定</button>
		</template>

		<input
			ref="fileInput"
			type="file"
			accept="image/*"
			class="g-header-info-card-v2-edit__file-input"
			@change="onFileChange"
		/>

		<JumpLink
			:visible="jumpLinkVisible"
			:jumpLink="selectedSlide?.jumpLink || emptyJumpLink"
			:linkTypes="['qrcode']"
			@submit="onJumpLinkSubmit"
			@cancel="jumpLinkVisible = false"
		/>
	</a-modal>
</template>

<script>
	import EditListSortGroup from './EditListSortGroup.vue';
	import ColorPicker from './ColorPicker.vue';
	import {
		getEditListSortItemClass,
		handleEditListSortDragEnd,
		handleEditListSortDragOver,
		handleEditListSortDragStart,
		resolveSelectedIndexAfterListMove,
	} from '../utils/editListDragSort.js';
	import JumpLink from '@/components/jumpLink.vue';
	import { filterValidLocalFiles, revokeLocalImageUrl } from '../utils/localImage.js';
	import UploadProgressPanel from './UploadProgressPanel.vue';
	import {
		createUploadTasks,
		updateUploadTaskProgress,
		uploadHeaderMediaFiles,
	} from '../utils/uploadHeaderMedia.js';
	import { createEmptyJumpLink, formatJumpLinkLabel } from '../utils/jumpLink.js';
	import { ensureEditFloatPanelVisible } from '../utils/editPanelAlign.js';
	import {
		createDefaultHeaderInfoCardV2Slide,
		getHeaderInfoCardV2Defaults,
		getHeaderInfoCardV2ImageUrl,
		HEADER_INFO_CARD_V2_DEFAULT_AUTOPLAY_INTERVAL,
		HEADER_INFO_CARD_V2_DEFAULT_EDGE_SIZE,
		HEADER_INFO_CARD_V2_DEFAULT_HEIGHT,
		HEADER_INFO_CARD_V2_MAX_SLIDES,
		normalizeHeaderInfoCardV2Data,
	} from '../utils/headerInfoCardV2.js';

	export default {
		name: 'GHeaderInfoCardV2EditModal',
		components: { EditListSortGroup, JumpLink, UploadProgressPanel, ColorPicker },
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			value: {
				type: Object,
				default: () => ({}),
			},
		},
		emits: ['update:visible', 'confirm', 'cancel'],
		data() {
			return {
				form: getHeaderInfoCardV2Defaults(),
				selectedIndex: 0,
				activePanel: '',
				heightDraft: HEADER_INFO_CARD_V2_DEFAULT_HEIGHT,
				autoplayIntervalDraft: Math.round(HEADER_INFO_CARD_V2_DEFAULT_AUTOPLAY_INTERVAL / 1000),
				dragId: '',
				dragOverId: '',
				jumpLinkVisible: false,
				emptyJumpLink: createEmptyJumpLink(),
				maxSlides: HEADER_INFO_CARD_V2_MAX_SLIDES,
				isUploading: false,
				uploadTasks: [],
			};
		},
		computed: {
			selectedSlide() {
				return this.form.items[this.selectedIndex] || null;
			},
			previewWrapStyle() {
				return {
					height: `${this.form.height}px`,
					'--g-edge-size': `${HEADER_INFO_CARD_V2_DEFAULT_EDGE_SIZE}px`,
				};
			},
			jumpLinkLabel() {
				return formatJumpLinkLabel(this.selectedSlide?.jumpLink);
			},
		},
		watch: {
			visible(val) {
				if (val) {
					this.selectedIndex = 0;
					this.activePanel = '';
					this.dragId = '';
					this.dragOverId = '';
					this.syncForm();
				}
			},
			value: {
				deep: true,
				handler() {
					if (this.visible) {
						this.syncForm();
					}
				},
			},
		},
		methods: {
			getEditListSortItemClass,
			syncForm() {
				this.form = normalizeHeaderInfoCardV2Data(this.value);
				this.heightDraft = this.form.height;
				this.autoplayIntervalDraft = Math.max(1, Math.round(this.form.autoplayInterval / 1000));
				if (this.selectedIndex >= this.form.items.length) {
					this.selectedIndex = Math.max(0, this.form.items.length - 1);
				}
			},
			getImageUrl(slide) {
				return getHeaderInfoCardV2ImageUrl(slide?.image);
			},
			getDotPreviewStyle(index) {
				const isActive = this.selectedIndex === index;
				return {
					background: isActive ? this.form.dotActiveColor : this.form.dotColor,
					width: '14px',
					height: '4px',
					borderRadius: '2px',
				};
			},
			selectSlide(index) {
				this.selectedIndex = index;
				this.activePanel = '';
				this.ensureActivePanelVisible();
			},
			ensureActivePanelVisible() {
				ensureEditFloatPanelVisible(this, {
					wrapSelector: '.g-header-info-card-v2-edit__thumb-wrap',
					panelSelector: '.g-header-info-card-v2-edit__panel--float',
				});
			},
			clearSelection() {
				this.activePanel = '';
			},
			goPrev() {
				const next = (this.selectedIndex - 1 + this.form.items.length) % this.form.items.length;
				this.selectSlide(next);
			},
			goNext() {
				const next = (this.selectedIndex + 1) % this.form.items.length;
				this.selectSlide(next);
			},
			togglePanel(panel) {
				this.activePanel = this.activePanel === panel ? '' : panel;
				if (panel === 'height') {
					this.heightDraft = this.form.height;
				}
				if (panel === 'autoplay') {
					this.autoplayIntervalDraft = Math.max(1, Math.round(this.form.autoplayInterval / 1000));
				}
				if (this.activePanel) {
					this.ensureActivePanelVisible();
				}
			},
			applyHeight() {
				this.form.height = Math.max(80, Number(this.heightDraft) || HEADER_INFO_CARD_V2_DEFAULT_HEIGHT);
				this.activePanel = '';
			},
			applyAutoplayInterval() {
				this.form.autoplayInterval = Math.max(1, Number(this.autoplayIntervalDraft) || 1) * 1000;
				this.form.autoplay = true;
				this.activePanel = '';
			},
			onEdgeColorInput(color) {
				this.form.edgeColor = color;
			},
			onDotColorInput(color) {
				this.form.dotColor = color;
			},
			onDotActiveColorInput(color) {
				this.form.dotActiveColor = color;
			},
			onTitleColorInput(color) {
				this.form.titleColor = color;
			},
			onSubtitleColorInput(color) {
				this.form.subtitleColor = color;
			},
			triggerImageSelect() {
				this.$refs.fileInput.value = '';
				this.$refs.fileInput.click();
			},
			async onFileChange(event) {
				const file = filterValidLocalFiles(Array.from(event.target.files || []), 1)[0];
				event.target.value = '';
				if (!file || !this.selectedSlide) return;
				this.isUploading = true;
				this.uploadTasks = createUploadTasks([file]);
				try {
					const [item] = await uploadHeaderMediaFiles(this, {
						type: 'image',
						files: [file],
						onProgress: payload => updateUploadTaskProgress(this.uploadTasks, payload),
					});
					if (this.selectedSlide.image?.local) {
						revokeLocalImageUrl(this.selectedSlide.image.previewUrl);
					}
					this.selectedSlide.image = item;
				} catch (error) {
					this.$message?.error?.('上传失败');
				} finally {
					this.isUploading = false;
					this.uploadTasks = [];
				}
			},
			onJumpLinkSubmit(link) {
				if (this.selectedSlide) {
					this.selectedSlide.jumpLink = link?.type ? { ...link } : null;
				}
				this.jumpLinkVisible = false;
			},
			addSlide() {
				if (this.form.items.length >= this.maxSlides) return;
				this.form.items.push(createDefaultHeaderInfoCardV2Slide(this.form.items.length));
				this.selectedIndex = this.form.items.length - 1;
			},
			deleteSlide(index) {
				if (this.form.items.length <= 1) return;
				this.form.items.splice(index, 1);
				if (this.selectedIndex >= this.form.items.length) {
					this.selectedIndex = this.form.items.length - 1;
				}
			},
			onDragStart(id, event) {
				handleEditListSortDragStart(this, id);
				event.dataTransfer.effectAllowed = 'move';
			},
			onSortDragOver(event) {
				handleEditListSortDragOver(event, this.$refs.editGrid, this);
			},
			onDragEnd() {
				handleEditListSortDragEnd(this, this.$refs.editGrid, this.form.items, this, (result) => {
					this.selectedIndex = resolveSelectedIndexAfterListMove(
						this.selectedIndex,
						result.fromIndex,
						result.toIndex,
					);
				});
			},
			onCancel() {
				this.$emit('update:visible', false);
				this.$emit('cancel');
			},
			onConfirm() {
				this.$emit('confirm', normalizeHeaderInfoCardV2Data(this.form));
				this.$emit('update:visible', false);
			},
		},
	};
</script>

<style scoped lang="less">
	.g-header-info-card-v2-edit {
		overflow: visible;
	}

	.g-header-info-card-v2-edit__stage {
		display: flex;
		align-items: center;
		gap: 12px;
		margin-bottom: 16px;
	}

	.g-header-info-card-v2-edit__nav {
		flex-shrink: 0;
		width: 32px;
		height: 32px;
		border: 1px solid #eceef2;
		border-radius: 50%;
		background: #fff;
		color: #666;
		cursor: pointer;
		display: inline-flex;
		align-items: center;
		justify-content: center;

		&:hover {
			color: #285af9;
			border-color: #285af9;
		}

		i {
			font-size: 14px;
			line-height: 1;
		}
	}

	.g-header-info-card-v2-edit__nav-icon--prev {
		display: inline-block;
		transform: rotate(180deg);
	}

	.g-header-info-card-v2-edit__preview {
		position: relative;
		flex: 1;
		min-width: 0;
		overflow: hidden;
		background: #f5f5f5;
		clip-path: polygon(
			0 0,
			100% 0,
			100% calc(100% - var(--g-edge-size, 36px) * 0.55),
			50% 100%,
			0 calc(100% - var(--g-edge-size, 36px) * 0.55)
		);
	}

	.g-header-info-card-v2-edit__preview-bg {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		clip-path: polygon(0% 0%, 0 0, 0% calc(100% - 38px), 50% 100%, 100% calc(100% - 38px), 100% 0%, 100% 0%);
	}

	.g-header-info-card-v2-edit__preview-empty {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		color: #bfbfbf;

		i {
			font-size: 36px;
		}
	}

	.g-header-info-card-v2-edit__text {
		position: absolute;
		left: 0;
		right: 0;
		top: 20%;
		z-index: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0 28px;
		pointer-events: auto;
	}

	.g-header-info-card-v2-edit__title-input,
	.g-header-info-card-v2-edit__subtitle-input {
		width: 100%;
		max-width: 520px;
		border: none;
		background: transparent;
		text-align: center;
		outline: none;
		padding: 0;
		text-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);

		&::placeholder {
			color: rgba(255, 255, 255, 0.55);
		}
	}

	.g-header-info-card-v2-edit__title-input {
		font-size: 28px;
		font-weight: 700;
		line-height: 1.35;
	}

	.g-header-info-card-v2-edit__subtitle-input {
		margin-top: 8px;
		font-size: 16px;
		font-weight: 400;
		line-height: 1.4;
	}

	.g-header-info-card-v2-edit__dots-preview {
		position: absolute;
		right: 12px;
		bottom: calc(var(--g-edge-size, 36px) + 10px);
		z-index: 3;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 5px;
		pointer-events: none;
	}

	.g-header-info-card-v2-edit__dot-preview {
		display: inline-block;
		flex-shrink: 0;
	}

	.g-header-info-card-v2-edit__edge {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: -1;
		height: var(--g-edge-size, 36px);
		clip-path: polygon(0 0, 100% 0, 100% 45%, 50% 100%, 0 45%);
		pointer-events: none;
	}

	.g-header-info-card-v2-edit__thumb-row {
		padding-left: 42px;
		overflow: visible; 
	}

	.g-header-info-card-v2-edit__thumbs {
		display: flex;
		align-items: flex-start;
		flex-wrap: wrap;
		gap: 10px;
	}

	.g-header-info-card-v2-edit__thumb-wrap {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		z-index: 0;

		&.is-active {
			z-index: 2;
		}
	}

	.g-header-info-card-v2-edit__thumb {
		position: relative;
		width: 72px;
		height: 72px;
		border: 2px solid transparent;
		overflow: hidden;
		border-radius: 4px;
		background: #fafafa;
		cursor: pointer;
		box-sizing: border-box;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			display: block;
		}

		i {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			height: 100%;
			font-size: 24px;
			color: #bfbfbf;
		}

		&.is-selected {
			border-color: #285af9;
		}

		&.is-dragging {
			opacity: 0.45;
		}

		&.is-drag-over {
			box-shadow: inset 0 0 0 2px #285af9;
		}

		&--add {
			display: flex;
			align-items: center;
			justify-content: center;
			border: 1px dashed #d9d9d9;
			color: #999;
			font-size: 24px;
			line-height: 1;
		}
	}

	.g-header-info-card-v2-edit__thumb-delete {
		position: absolute;
		top: 2px;
		right: 2px;
		width: 16px;
		height: 16px;
		border: none;
		border-radius: 50%;
		background: rgba(0, 0, 0, 0.55);
		color: #fff;
		font-size: 12px;
		line-height: 16px;
		padding: 0;
		cursor: pointer;
	}

	.g-header-info-card-v2-edit__sort-tip {
		margin: 8px 0 0;
		font-size: 12px;
		color: #999;
	}

	.g-header-info-card-v2-edit__panel {
		background: #fff;
		border: 1px solid #eceef2;
		border-radius: 4px;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
		overflow: visible;
		width: max-content;
		max-width: 100%;

		&--float {
			position: absolute;
			top: calc(100% + 8px);
			left: 0;
			z-index: 10;
			display: inline-block;
			width: auto;
			max-width: none;
		}

		&--arrow::before {
			content: '';
			position: absolute;
			top: -5px;
			left: 36px;
			width: 10px;
			height: 10px;
			background: #fff;
			border-left: 1px solid #eceef2;
			border-top: 1px solid #eceef2;
			transform: translateX(-50%) rotate(45deg);
			z-index: 1;
		}
	}

	.g-header-info-card-v2-edit__link-row {
		display: flex;
		align-items: center;
		gap: 8px;
		min-height: 40px;
		padding: 0 14px;
		border-bottom: 1px solid #f0f0f0;
		font-size: 13px;
		color: #333;
		white-space: nowrap;

		i {
			color: #999;
			font-size: 14px;
		}

		.is-empty {
			color: #999;
		}
	}

	.g-header-info-card-v2-edit__toolbar {
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
		gap: 0;
		min-height: 40px;
		padding: 0 10px;
	}

	.g-header-info-card-v2-edit__action-wrap {
		position: relative;
		display: inline-flex;
		flex-shrink: 0;
	}

	.g-header-info-card-v2-edit__action {
		border: none;
		background: transparent;
		padding: 0 10px;
		font-size: 13px;
		color: #285af9;
		cursor: pointer;
		line-height: 32px;
		white-space: nowrap;
		flex-shrink: 0;

		&:hover:not(:disabled) {
			color: #1d4ed8;
		}

		&.is-active {
			font-weight: 600;
		}

		&:disabled {
			color: #bbb;
			cursor: not-allowed;
		}

		&--danger-text {
			color: #ff4d4f;

			&:hover:not(:disabled) {
				color: #cf1322;
			}
		}
	}

	.g-header-info-card-v2-edit__sub-panel {
		position: absolute;
		left: 0;
		top: calc(100% + 8px);
		z-index: 20;
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 10px 12px;
		background: #fff;
		border: 1px solid #eceef2;
		border-radius: 6px;
		box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
		white-space: nowrap;
	}

	.g-header-info-card-v2-edit__sub-label {
		font-size: 13px;
		color: #666;
	}

	.g-header-info-card-v2-edit__sub-input {
		width: 96px;
	}

	.g-header-info-card-v2-edit__sub-confirm {
		border: none;
		background: #285af9;
		color: #fff;
		border-radius: 4px;
		padding: 0 12px;
		height: 28px;
		font-size: 13px;
		cursor: pointer;
	}

	.g-header-info-card-v2-edit__colors {
		display: flex;
		align-items: center;
		gap: 8px;
		padding-left: 8px;
	}

	.g-header-info-card-v2-edit__file-input {
		display: none;
	}

	.g-header-info-card-v2-edit__footer-btn {
		min-width: 72px;
		height: 32px;
		padding: 0 16px;
		border: 1px solid #d9d9d9;
		border-radius: 4px;
		background: #fff;
		font-size: 14px;
		color: #666;
		cursor: pointer;

		&.is-confirm {
			border-color: #285af9;
			background: #285af9;
			color: #fff;
		}

		& + & {
			margin-left: 10px;
		}

		&:disabled {
			opacity: 0.6;
			cursor: not-allowed;
		}
	}
</style>
